module.exports = __webpack_public_path__ + "img/card_掼蛋赛事@2x.df9c2c7b.png";